<template>
  <modal
    name="censoredInfo"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    :classes="['custom']"
    :clickToClose="false"
    :width="446"
    :height="'auto'"
    :min-height="200"
  >
    <div class="container censored-info">
      <div class="heading">
        违规内容
        <div class="close icon-popup-close" @click="close"></div>
      </div>
      <div class="figure-section" v-if="false">
        <div class="frame">
          <img :src="url" alt="">
        </div>
      </div>
      <div class="type-section">
        <div class="title-row">违规类型</div>
        <div>{{ typeText }}</div>
      </div>
      <div class="explanation-section">
        <div class="link-row">
          <span class="title">常见违规问题</span>
          <span class="link" @click="link('https://support.qq.com/products/408104/faqs-more/?id=121200')">更多说明</span>
        </div>
        <div class="types">
          <div v-for="item, i in censoredTypes" :key="i" class="censored-type">
            {{item.explanation}}
          </div>
        </div>
      </div>
      <div class="footer">
        <span>仍有疑问？</span><span class="link" @click="showSupportStaff">联系客服</span>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      typeText: '',
      url: '',
      censoredTypes: [
        { title: '', explanation: '涉政：出现敏感人物与话题、地图不完整等疑似内容' },
        { title: '', explanation: '暴恐：出现管制刀具、枪支或暴恐等疑似内容' },
        { title: '', explanation: '色情：出现暴露、色情等疑似内容' },
        { title: '', explanation: '敏感：出现诈骗、走私、洗钱等疑似内容' },
        { title: '', explanation: '违法违禁：出现赌博、吸毒、毒品等疑似内容' }
      ]
    }
  },
  methods: {
    beforeOpen ({params}) {
      const data = params.data;
      this.typeText = data.censorType;
      this.url = data.url.replace(/\.[^.]+$/, (m) => {
        return 'nail' + m;
      });
    },
    close () {
      this.$modal.hide('censoredInfo');
    },
    showSupportStaff () {
      this.$store.dispatch('showServiceChat');
    },
    link (url) {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.click();
      a.remove();
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  margin: auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
  text-align: left;
}
.heading {
  height: 60px;
  background: #F0F0F8;
  opacity: 1;
  border-radius: 4px 4px 0px 0px;
  padding-top: 21px;
  padding-left: 36px;
  padding-right: 36px;
  font-size: 16px;
  font-weight: bold;
  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
}
.figure-section {
  padding: 16px 32px;
  .frame {
    width: 382px;
    height: 215px;
    background: #F8F8FB;
    opacity: 1;
    border-radius: 0px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.type-section {
  padding: 20px 32px;
  .title-row {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &>div:nth-child(2) {
    color: #606266;
  }
}
.explanation-section {
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 30px;
  .link-row {
    padding-bottom: 10px;
    font-size: 12px;
    .title {
      font-weight: bold;
      margin-right: 6px;
    }
    .link {
      color: #113DF5;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .types {
    color: #606266;
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  background: #F8F8FC;
  opacity: 1;
  border-radius: 0px 0px 6px 6px;
  color: #666A80;
  font-size: 12px;
  .link {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/censoredInfo/censoredInfo.vue